import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RefactorRoutingModule } from './refactor-routing.module';
import { MainComponent } from './pages/main/main.component';
import { UploadedFilesComponent } from './pages/uploaded-files/uploaded-files.component';
import { GenerateCodeComponent } from './pages/generate-code/generate-code.component';
import { ShowCodeComponent } from './pages/show-code/show-code.component';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { RefactorCardHeaderComponent } from './shared/refactor-card-header/refactor-card-header.component';
import { AnalysisDashboardComponent } from './components/analysis-dashboard/analysis-dashboard.component';
import { SharedModule } from '../../shared/shared.module';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    MainComponent,
    UploadedFilesComponent,
    GenerateCodeComponent,
    ShowCodeComponent,
    RefactorCardHeaderComponent,
    AnalysisDashboardComponent
  ],
  imports: [
    CommonModule,
    RefactorRoutingModule,
    SharedModule,
    FormsModule,
    IonicModule,
    MonacoEditorModule.forRoot(), // use forRoot() in main app module only.
    TranslateModule
  ],
  exports:[
    MainComponent,
    UploadedFilesComponent,
    GenerateCodeComponent,
    ShowCodeComponent,
    RefactorCardHeaderComponent,
    AnalysisDashboardComponent
  ]
})
export class RefactorModule { }
